import React, { FC } from 'react';
import style from './style.module.less';
import CloseIcon from './close.svg?react';

interface Props {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  toastClassName?: string;
  onClose: () => void;
}

export const ToastModal: FC<Props> = (props) => {
  const { isOpen, onClose, title, children, toastClassName } = props;

  return (
    isOpen && (
      <div className={`${style.container} ${toastClassName || ''}`}>
        <div className={style.header}>
          <div className={style.title}>{title}</div>
          <CloseIcon className={style.closeIcon} onClick={onClose} />
        </div>
        {children}
      </div>
    )
  );
};
